





















































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { storeHasilPenunjang } from "@/store/modules/HasilPenunjang";

interface HasilLab {
  no_order: string;
  tgl_order: string;
  no_trans: string;
  lis_sampel: string;
  acc_by: string;
  acc_date: string;
  unit: {
    id: string;
    nama: string;
  };
  hasil: Array<{
    test_id: string;
    nama_test: string;
    jenis_hasil: string;
    hasil: string;
    satuan: string;
    nilai_normal: string;
    flag: string;
    kode_paket: string;
    reserve4: string;
  }>;
  hasil_mikro: string;
}

interface SubItemHasil {
  sample_id: string;
  test_id: string;
  nama_test: string;
  hasil: string;
  satuan: string;
}

@Component({
  components: {}
})
export default class TableHasilLabForResume extends Vue {
  @Prop() selectedId;
  @Prop({ default: [], type: Array }) selectedSubItems: SubItemHasil[];
  @Prop() register;
  @Prop({ default: false, type: Boolean }) showSelect: boolean;
  @Prop({ default: false, type: Boolean }) showActions: boolean;
  @Prop({ default: false, type: Boolean }) showReload: boolean;
  @Prop({ default: "asc", type: Boolean }) sort: "asc" | "desc";

  tblHeight = "500";
  headers = [
    {
      text: "Tgl Hasil",
      align: "start",
      value: "acc_date"
    },
    { text: "Unit", value: "unit.nama" },
    { text: "Acc Oleh", value: "acc_by" },
    { text: "Item Pemeriksaan", value: "items" },
    { text: "", value: "data-table-expand" }
  ];

  selectedItem = [];
  expanded = [];
  subItemSelected: SubItemHasil[] = [];
  selectAllSub = [];

  @Watch("selectedItem")
  changedselectedItem(val) {
    this.$emit("selectedItem", val);
  }

  @Watch("selectedId")
  changedSelectedId(val) {
    const ids = Array.isArray(val) ? val : [val];
    this.selectedItem = this.renderedResultList.filter(
      item => ids && ids.includes(item.lis_sampel)
    );
  }

  @Watch("selectedSubItems")
  changedSelectedSubItems(val) {
    console.log("selectedSubItems", val);
    this.subItemSelected = val;
  }

  @Watch("subItemSelected")
  changedSubItemSelected(val) {
    console.log("subItemSelected", val);
    this.$emit("selectedSubItems", val);
  }

  @Watch("showActions")
  changedShowActions(val) {
    if (val) {
      this.headers.push({ text: "Aksi", value: "id" });
    } else {
      this.headers.splice(
        this.headers.findIndex(item => item.text == "Aksi"),
        1
      );
    }
  }

  @Watch("loadingList")
  changeLoadingList(newVal: boolean, oldVal: boolean) {
    console.log("changeLoadingList", newVal, oldVal);
    this.onItemExpanded();

    // this.expanded = this.renderedResultList ? [this.renderedResultList[0]] : [];

    // if (!newVal) {
    //   this.expanded = this.renderedResultList
    //     ? [this.renderedResultList[0]]
    //     : [];
    // }
  }

  @Watch("renderedResultList")
  changeRenderedResultList(newVal, oldVal) {
    this.onItemExpanded();
    if (newVal && newVal.length > 0) {
      this.expanded = [this.renderedResultList[0]];
    }
  }

  get selectedGroup() {
    return (
      this.subItemSelected
        .map(sub => sub.sample_id)
        // get unique value
        .filter((value, index, array) => {
          return array.indexOf(value) === index;
        })
    );
  }

  get rawResultListDummy() {
    return [
      {
        no_order: "446",
        tgl_order: "2023-04-03",
        no_trans: "123",
        lis_sampel: "2304030013",
        acc_by: "Atik E, Amd.AK",
        acc_date: "2023-04-03 12:06:54",
        unit: {
          id: "01",
          nama: "IGD"
        },
        hasil: [
          {
            test_id: "LKS04",
            nama_test: "Glukosa Darah Sewaktu",
            jenis_hasil: "NUMERIK",
            hasil: "163",
            satuan: "mg/dl",
            nilai_normal: "80 - 200",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "PHGAS",
            nama_test: "pH",
            jenis_hasil: "NUMERIK",
            hasil: "7.470",
            satuan: null,
            nilai_normal: "7.350 - 7.450",
            flag: "H",
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PCO2",
            nama_test: "PCO2",
            jenis_hasil: "NUMERIK",
            hasil: "40.0",
            satuan: "mmHg",
            nilai_normal: "36.0 - 44.0",
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PO2",
            nama_test: "PO2",
            jenis_hasil: "NUMERIK",
            hasil: "88.0",
            satuan: "mmHg",
            nilai_normal: "80.0 - 100.0",
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "HCO3",
            nama_test: "HCO3",
            jenis_hasil: "NUMERIK",
            hasil: "28.2",
            satuan: "meq/l",
            nilai_normal: "22.0 - 28.0",
            flag: "H",
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "O2S",
            nama_test: "SO2",
            jenis_hasil: "NUMERIK",
            hasil: "97.0",
            satuan: "%",
            nilai_normal: "94.0 - 98.0",
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "BE",
            nama_test: "BE (Base Excess)",
            jenis_hasil: "NUMERIK",
            hasil: "4.9",
            satuan: "mmol/L",
            nilai_normal: "-2.0 - 2.0",
            flag: "H",
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "TCO2",
            nama_test: "TCO2",
            jenis_hasil: "NUMERIK",
            hasil: "29.3",
            satuan: "mmol/L",
            nilai_normal: "23.0 - 27.0",
            flag: "H",
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "LKB31",
            nama_test: "Laktat",
            jenis_hasil: "NUMERIK",
            hasil: "1.3",
            satuan: "mmol/L",
            nilai_normal: "0.5 - 2.2",
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "AADO2",
            nama_test: "A-aDO2",
            jenis_hasil: "NUMERIK",
            hasil: "126.00",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PAO2",
            nama_test: "pAO2",
            jenis_hasil: "NUMERIK",
            hasil: "214.00",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "RI",
            nama_test: "RI",
            jenis_hasil: "NUMERIK",
            hasil: "1.40",
            satuan: null,
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PF",
            nama_test: "PF",
            jenis_hasil: "NUMERIK",
            hasil: "214.00",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PAOPAO",
            nama_test: "paO2/pA02",
            jenis_hasil: "NUMERIK",
            hasil: "0.41",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "LKB22",
            nama_test: "Natrium",
            jenis_hasil: "NUMERIK",
            hasil: "149.9",
            satuan: "mmol/l",
            nilai_normal: "137.0 - 145.0",
            flag: "H",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB23",
            nama_test: "Kalium",
            jenis_hasil: "NUMERIK",
            hasil: "3.73",
            satuan: "mmol/l",
            nilai_normal: "3.50 - 5.10",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB24",
            nama_test: "Klorida",
            jenis_hasil: "NUMERIK",
            hasil: "115.9",
            satuan: "mmol/l",
            nilai_normal: "98.0 - 107.0",
            flag: "H",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LHA01",
            nama_test: "Lekosit",
            jenis_hasil: "NUMERIK",
            hasil: "25.03",
            satuan: "10^3/uL",
            nilai_normal: "4.00 - 11.00",
            flag: "H",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LHA04",
            nama_test: "Eritrosit",
            jenis_hasil: "NUMERIK",
            hasil: "3.53",
            satuan: "10^6/uL",
            nilai_normal: "4.50 - 5.50",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LHA05",
            nama_test: "Trombosit",
            jenis_hasil: "NUMERIK",
            hasil: "255",
            satuan: "10^3/uL",
            nilai_normal: "150 - 450",
            flag: null,
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LHA06",
            nama_test: "Hematokrit",
            jenis_hasil: "NUMERIK",
            hasil: "35.1",
            satuan: "vol%",
            nilai_normal: "42.0 - 52.0",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "EOS",
            nama_test: "Eosinofil",
            jenis_hasil: "NUMERIK",
            hasil: "1",
            satuan: "%",
            nilai_normal: "2 - 4",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "BASOFIL",
            nama_test: "Basofil",
            jenis_hasil: "NUMERIK",
            hasil: "0",
            satuan: "%",
            nilai_normal: "0 - 1",
            flag: null,
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "BATNG",
            nama_test: "Batang",
            jenis_hasil: "NUMERIK",
            hasil: "0",
            satuan: "%",
            nilai_normal: "2 - 5",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "SEGMEN",
            nama_test: "Segmen",
            jenis_hasil: "NUMERIK",
            hasil: "79",
            satuan: "%",
            nilai_normal: "51 - 67",
            flag: "H",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LIMFOSIT",
            nama_test: "Limfosit",
            jenis_hasil: "NUMERIK",
            hasil: "8",
            satuan: "%",
            nilai_normal: "20 - 35",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "MONOSIT",
            nama_test: "Monosit",
            jenis_hasil: "NUMERIK",
            hasil: "12",
            satuan: "%",
            nilai_normal: "4 - 8",
            flag: "H",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LKS04",
            nama_test: "Glukosa Darah Sewaktu",
            jenis_hasil: "NUMERIK",
            hasil: "136",
            satuan: "mg/dl",
            nilai_normal: "80 - 200",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB22",
            nama_test: "Natrium",
            jenis_hasil: "NUMERIK",
            hasil: "144.9",
            satuan: "mmol/l",
            nilai_normal: "137.0 - 145.0",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB23",
            nama_test: "Kalium",
            jenis_hasil: "NUMERIK",
            hasil: "3.57",
            satuan: "mmol/l",
            nilai_normal: "3.50 - 5.10",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB24",
            nama_test: "Klorida",
            jenis_hasil: "NUMERIK",
            hasil: "110.3",
            satuan: "mmol/l",
            nilai_normal: "98.0 - 107.0",
            flag: "H",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB22",
            nama_test: "Natrium",
            jenis_hasil: "NUMERIK",
            hasil: "143.0",
            satuan: "mmol/l",
            nilai_normal: "137.0 - 145.0",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB23",
            nama_test: "Kalium",
            jenis_hasil: "NUMERIK",
            hasil: "3.90",
            satuan: "mmol/l",
            nilai_normal: "3.50 - 5.10",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB24",
            nama_test: "Klorida",
            jenis_hasil: "NUMERIK",
            hasil: "108.0",
            satuan: "mmol/l",
            nilai_normal: "98.0 - 107.0",
            flag: "H",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB22",
            nama_test: "Natrium",
            jenis_hasil: "NUMERIK",
            hasil: "138.3",
            satuan: "mmol/l",
            nilai_normal: "137.0 - 145.0",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB23",
            nama_test: "Kalium",
            jenis_hasil: "NUMERIK",
            hasil: "3.91",
            satuan: "mmol/l",
            nilai_normal: "3.50 - 5.10",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB24",
            nama_test: "Klorida",
            jenis_hasil: "NUMERIK",
            hasil: "101.1",
            satuan: "mmol/l",
            nilai_normal: "98.0 - 107.0",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB22",
            nama_test: "Natrium",
            jenis_hasil: "NUMERIK",
            hasil: "133.3",
            satuan: "mmol/l",
            nilai_normal: "137.0 - 145.0",
            flag: "L",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB23",
            nama_test: "Kalium",
            jenis_hasil: "NUMERIK",
            hasil: "4.12",
            satuan: "mmol/l",
            nilai_normal: "3.50 - 5.10",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB24",
            nama_test: "Klorida",
            jenis_hasil: "NUMERIK",
            hasil: "98.2",
            satuan: "mmol/l",
            nilai_normal: "98.0 - 107.0",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB22",
            nama_test: "Natrium",
            jenis_hasil: "NUMERIK",
            hasil: "129.4",
            satuan: "mmol/l",
            nilai_normal: "137.0 - 145.0",
            flag: "L",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB23",
            nama_test: "Kalium",
            jenis_hasil: "NUMERIK",
            hasil: "4.11",
            satuan: "mmol/l",
            nilai_normal: "3.50 - 5.10",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB24",
            nama_test: "Klorida",
            jenis_hasil: "NUMERIK",
            hasil: "93.8",
            satuan: "mmol/l",
            nilai_normal: "98.0 - 107.0",
            flag: "L",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "PCO2",
            nama_test: "PCO2",
            jenis_hasil: "NUMERIK",
            hasil: "34.0",
            satuan: "mmHg",
            nilai_normal: "36.0 - 44.0",
            flag: "L",
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PO2",
            nama_test: "PO2",
            jenis_hasil: "NUMERIK",
            hasil: "198.0",
            satuan: "mmHg",
            nilai_normal: "80.0 - 100.0",
            flag: "H",
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "LKB31",
            nama_test: "Laktat",
            jenis_hasil: "NUMERIK",
            hasil: "1.4",
            satuan: "mmol/L",
            nilai_normal: "0.5 - 2.2",
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "AADO2",
            nama_test: "A-aDO2",
            jenis_hasil: "NUMERIK",
            hasil: "194.00",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PAO2",
            nama_test: "pAO2",
            jenis_hasil: "NUMERIK",
            hasil: "392.00",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "RI",
            nama_test: "RI",
            jenis_hasil: "NUMERIK",
            hasil: "1.00",
            satuan: null,
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PF",
            nama_test: "PF",
            jenis_hasil: "NUMERIK",
            hasil: "334.00",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "PAOPAO",
            nama_test: "paO2/pA02",
            jenis_hasil: "NUMERIK",
            hasil: "0.51",
            satuan: "mmHg",
            nilai_normal: null,
            flag: null,
            kode_paket: "LKB32",
            reserve4: ""
          },
          {
            test_id: "LUA28",
            nama_test: "APTT",
            jenis_hasil: "NUMERIK",
            hasil: "26.3",
            satuan: "detik",
            nilai_normal: "28.0 - 38.0",
            flag: "L",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "CPT",
            nama_test: "Control PPT",
            jenis_hasil: "NUMERIK",
            hasil: "14.5",
            satuan: "detik",
            nilai_normal: "11.0 - 16.0",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "CAPTT",
            nama_test: "Control APTT",
            jenis_hasil: "NUMERIK",
            hasil: "32.9",
            satuan: "detik",
            nilai_normal: "28.0 - 36.5",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB12",
            nama_test: "Protein Total",
            jenis_hasil: "NUMERIK",
            hasil: "7.70",
            satuan: "g/dl",
            nilai_normal: "6.20 - 8.40",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB13",
            nama_test: "Albumin",
            jenis_hasil: "NUMERIK",
            hasil: "3.74",
            satuan: "g/dl",
            nilai_normal: "3.50 - 5.50",
            flag: null,
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LKB14",
            nama_test: "Globulin",
            jenis_hasil: "NUMERIK",
            hasil: "3.96",
            satuan: "g/dl",
            nilai_normal: "2.80 - 3.20",
            flag: "H",
            kode_paket: null,
            reserve4: ""
          },
          {
            test_id: "LHA01",
            nama_test: "Lekosit",
            jenis_hasil: "NUMERIK",
            hasil: "26.24",
            satuan: "10^3/uL",
            nilai_normal: "4.00 - 11.00",
            flag: "H",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LHA04",
            nama_test: "Eritrosit",
            jenis_hasil: "NUMERIK",
            hasil: "3.99",
            satuan: "10^6/uL",
            nilai_normal: "4.50 - 5.50",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LHA05",
            nama_test: "Trombosit",
            jenis_hasil: "NUMERIK",
            hasil: "326",
            satuan: "10^3/uL",
            nilai_normal: "150 - 450",
            flag: null,
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "LHA06",
            nama_test: "Hematokrit",
            jenis_hasil: "NUMERIK",
            hasil: "36.4",
            satuan: "vol%",
            nilai_normal: "42.0 - 52.0",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "EOS",
            nama_test: "Eosinofil",
            jenis_hasil: "NUMERIK",
            hasil: "0",
            satuan: "%",
            nilai_normal: "2 - 4",
            flag: "L",
            kode_paket: "LB1",
            reserve4: ""
          },
          {
            test_id: "BASOFIL",
            nama_test: "Basofil",
            jenis_hasil: "NUMERIK",
            hasil: "0",
            satuan: "%",
            nilai_normal: "0 - 1",
            flag: null,
            kode_paket: "LB1",
            reserve4: ""
          }
        ],
        hasil_mikro: null
      },
      {
        no_order: "447",
        tgl_order: "2023-04-03",
        no_trans: "125",
        lis_sampel: "2304030015",
        acc_by: "Atik E, Amd.AK",
        acc_date: "2023-04-03 10:06:54",
        unit: {
          id: "01",
          nama: "IGD"
        },
        hasil: [
          {
            test_id: "LHB01",
            nama_test: "Hemoglobin",
            jenis_hasil: "NUMERIK",
            hasil: "15.5",
            satuan: "g/dl",
            nilai_normal: "14.0 - 18.0",
            flag: null,
            kode_paket: "LB1",
            reserve4: ""
          }
        ],
        hasil_mikro: null
      }
    ];
  }

  get resultList(): Array<HasilLab> {
    return storeHasilPenunjang.listHasilLab.map(item => {
      // return this.rawResultListDummy.map(item => {
      item["items"] = item.hasil.map(res => res.nama_test);

      return item;
    });
  }

  get renderedResultList() {
    return this.resultList.sort((a, b) => {
      return this.sort === "asc"
        ? new Date(a.acc_date).getTime() - new Date(b.acc_date).getTime()
        : new Date(b.acc_date).getTime() - new Date(a.acc_date).getTime();
    });
  }

  get loadingList() {
    return storeHasilPenunjang.loadingLab;
  }

  reload() {
    storeHasilPenunjang.getLabByRegister(this.register).then(res => {
      this.changedSelectedId(this.selectedId);
      this.onItemExpanded();

      console.log("response reload", res);

      // if (res && res.length > 0) {
      //   this.expanded = this.renderedResultList
      //     ? [this.renderedResultList[0]]
      //     : [];
      // }
    });
  }

  expandRow(item) {
    this.expanded.includes(item)
      ? this.expanded.splice(
          this.renderedResultList.findIndex(
            list => list.lis_sampel == item.lis_sampel
          ),
          1
        )
      : this.expanded.push(item);

    this.subItemSelected = [...this.subItemSelected];
  }

  onItemExpanded() {
    this.subItemSelected = [...this.subItemSelected];
  }

  onItemSelected(event: { item: HasilLab; value: boolean }) {
    console.log("on item selected", event);

    if (event.value) {
      this.addToSubItemSelected(event.item);
    } else {
      this.removeFromSubItemSelected(event.item);
    }
  }

  addToSubItemSelected(itemLab: HasilLab) {
    const filteredOut = this.subItemSelected.filter(
      item => item?.sample_id != itemLab.lis_sampel
    );

    const selItem = itemLab.hasil.map(hasil => {
      return this.formatSubItem(itemLab, hasil);
    });

    this.subItemSelected = [...filteredOut, ...selItem];
  }

  formatSubItem(parentItem: HasilLab, hasil) {
    return {
      sample_id: parentItem.lis_sampel,
      acc_date: parentItem.acc_date,
      test_id: hasil.test_id,
      nama_test: hasil.nama_test,
      hasil: hasil.hasil,
      satuan: hasil.satuan
    };
  }

  removeFromSubItemSelected(itemLab: HasilLab) {
    this.subItemSelected = this.subItemSelected.filter(
      item => item?.sample_id != itemLab.lis_sampel
    );
  }

  addCriticalItemToSubItemSelected(itemLab: HasilLab) {
    // deselect select all checkbox if any
    this.selectAllSub = this.selectAllSub.filter(
      ids => ids !== itemLab.lis_sampel
    );

    // filter out any existing item checked in this item sublist
    const filteredOut = this.subItemSelected.filter(
      item => item?.sample_id != itemLab.lis_sampel
    );

    // get all critical result and add to compilated sub items
    const selItem = itemLab.hasil
      .filter(item => ["L", "H"].includes(item.flag))
      .map(hasil => {
        return this.formatSubItem(itemLab, hasil);
      });

    this.subItemSelected = [...filteredOut, ...selItem];
  }

  toggleSubItem(lisSampelId: string) {
    if (this.selectAllSub && this.selectAllSub.includes(lisSampelId)) {
      // console.log("select all");
      const resActive = this.resultList.find(
        res => res.lis_sampel == lisSampelId
      );

      this.subItemSelected = [
        ...this.subItemSelected.filter(item => item?.sample_id != lisSampelId),
        ...resActive.hasil.map(item => {
          return this.formatSubItem(resActive, item);
        })
      ];
    } else {
      // console.log("deselect all");
      this.subItemSelected = [
        ...this.subItemSelected.filter(item => item?.sample_id != lisSampelId)
      ];
    }
  }

  subItemRowStyle(item, res) {
    return {
      backgroundColor: this.subItemSelected.find(sub => {
        return (
          sub.sample_id == item.lis_sampel &&
          sub.test_id == res.test_id &&
          sub.hasil == res.hasil
        );
      })
        ? "lightcyan"
        : ""
    };
  }
}
